import type { ReactNode } from "react"

export const FlowPanel = ({ children }: { children: ReactNode }) => (
  <main className="bg-surface-page flex min-h-dvh justify-center">
    <div data-testid="flow-panel" className="bg-surface relative flex h-dvh w-full max-w-md flex-col overflow-y-auto shadow-xl sm:max-w-lg md:max-w-xl lg:max-w-2xl">
      {children}
    </div>
  </main>
)
